<template>
 <div ref='plotContainer'>
   <svg ref='plot'></svg>
  </div>
</template>

<script>
  import * as d3 from 'd3'

  var pieArcs = d3.pie()
    .sort(null)
    .value(d => d.value)

  var cb1 = d3.rgb(251, 248, 176)
  var cb2 = d3.rgb(209, 60, 75)

  function linear(e,s,p,t){
    return ((e - s) * p / t) + s
  }

  function generatePlot(self, val) {
    if( !val ) {
      return
    }
    var pdata = []
    var ft = Object.keys(val.fail).length
    for(var fn in val.fail){
      var fo = {
        'name': fn || 'fail',
        'value': val.fail[fn]
      }
      var ip = 0
      for( ip = 0; ip < pdata.length; ip++ ) {
        if( pdata[ip].value < fo.value ) {
          pdata.splice(ip,0,fo)
          break
        }
      }
      if( ip === pdata.length ) {
        pdata.push(fo)
      }
    }
    for( ip = 0; ip < pdata.length; ip++ ) {
      pdata[ip].color = d3.rgb(
          linear(cb1.r,cb2.r,ip,ft - 1),
          linear(cb1.g,cb2.g,ip,ft - 1),
          linear(cb1.b,cb2.b,ip,ft - 1))
    }
    if( val.ok > 0 ) {
      pdata.splice(0,0,{'name': 'ok', 'value': val.ok, 'color': d3.rgb(126,201,166)})
    }
    const arcs = pieArcs(pdata)
    var width = self.$refs['plotContainer'].getBoundingClientRect().width
    width -= 10
    var height = width
    var sC = self.$refs['plot']
    sC.setAttribute('height', `${height}px`)
    sC.setAttribute('width', `${width}px`)

    var arc = d3.arc()
      .innerRadius(0)
      .outerRadius(Math.min(width, height) / 2 - 1)

    function arcLabel() {
      const radius = Math.min(width, height) / 2 * 0.6
      return d3.arc().innerRadius(radius).outerRadius(radius)
    }

    const svg = d3.select(sC)
      .attr('text-anchor', 'middle')
      .style('font', '12px sans-serif')
    const g = svg.append('g').attr('transform', `translate(${width / 2},${height / 2})`)
    g.selectAll('path')
      .data(arcs).enter()
      .append('path')
      .attr('fill', d => d.data.color)
      .attr('stroke', 'white')
      .attr('d', arc)
      .append('title').text(d => `${d.data.name}: ${d.data.value.toLocaleString()}`)
    const text = g.selectAll('text')
      .data(arcs)
      .enter().append('text')
      .attr('transform', d => `translate(${arcLabel().centroid(d)})`)
      .attr('dy', '0.35em')
    text.append('tspan')
      .attr('x', 0)
      .attr('y', '-0.7em')
      .style('font-weight', 'bold')
      .text(d => d.data.name)
    text.filter(d => (d.endAngle - d.startAngle) > 0.25).append('tspan')
      .attr('x', 0)
      .attr('y', '0.7em')
      .attr('fill-opacity', 0.7)
      .text(d => d.data.value.toLocaleString())
  }

  export default {
    name: 'results-plot',
    props: {
      data: Object
    },
    data() {
      return {
      }
    },
    mounted() {
      generatePlot(this,this.data)
    },
    watch: {
      data: function(val, oldV) {
        generatePlot(this,val)
      }
    }
  }
</script>




// WEBPACK FOOTER //
// results-plot.vue?eb0c1f2a